import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugcab() {



const cardData =
{
  keyword: 'Pune to Alibaug Cab',

  heading: 'Lotus Cab: Pune to Alibaug Cab Service',

  headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Alibaug Cab services for beach vacations, family holidays, weekend getaways, corporate outings, sightseeing tours, and one-way or round-trip journeys. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe highway travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free journey to Alibaug and the beautiful Konkan coastline.",


  top: 'Top Places to Visit in Alibaug with Lotus Cab',

  topPlaces: [
    {
        title: "Alibaug Beach",
        description:
            "Alibaug Beach is the most popular attraction in the coastal town and is known for its black sand shoreline, breathtaking sunsets, sea breeze, and panoramic views of the Arabian Sea. Visitors from Pune enjoy beach walks, horse cart rides, local seafood, photography, and relaxing evenings, making it the perfect destination for families, couples, and weekend travelers."
    },
    {
        title: "Kolaba Fort",
        description:
            "Kolaba Fort is a magnificent 17th-century sea fort built by Chhatrapati Shivaji Maharaj and is one of Alibaug's most iconic historical landmarks. Accessible on foot during low tide or by boat during high tide, the fort offers stunning sea views, ancient temples, and fascinating Maratha architecture, making it a must-visit destination for history enthusiasts."
    },
    {
        title: "Varsoli Beach",
        description:
            "Varsoli Beach is a peaceful and less crowded beach located close to Alibaug town. Known for its clean shoreline, coconut trees, and calm atmosphere, it is an ideal destination for families and travelers seeking relaxation away from the busy tourist areas while enjoying beautiful coastal scenery."
    },
    {
        title: "Nagaon Beach",
        description:
            "Nagaon Beach is one of the most popular beaches near Alibaug, famous for its water sports, soft sandy shoreline, beach resorts, and peaceful environment. Activities such as jet skiing, banana boat rides, parasailing, and speed boating attract adventure lovers and holidaymakers throughout the year."
    },
    {
        title: "Kihim Beach",
        description:
            "Kihim Beach is renowned for its natural beauty, lush greenery, migratory birds, and serene surroundings. The tranquil atmosphere makes it a favorite destination for photographers, birdwatchers, nature lovers, and couples looking for a peaceful beach getaway from Pune."
    },
    {
        title: "Murud-Janjira Fort",
        description:
            "Murud-Janjira Fort is one of India's strongest and most impressive sea forts, standing majestically in the Arabian Sea. The fort is famous for its remarkable architecture, rich history, and unbeaten legacy, attracting tourists interested in Maharashtra's maritime heritage and spectacular coastal landscapes."
    },
    {
        title: "Kashid Beach",
        description:
            "Kashid Beach is celebrated for its white sandy shoreline, crystal-clear waters, and picturesque surroundings. It is one of the finest beaches on the Konkan coast, ideal for swimming, beach activities, photography, and peaceful vacations with family and friends."
    },
    {
        title: "Revdanda Fort",
        description:
            "Revdanda Fort is a historic Portuguese fort located along the Konkan coast, featuring ancient stone walls, old church ruins, and beautiful sea-facing viewpoints. The fort combines history, architecture, and scenic coastal beauty, making it a worthwhile stop during an Alibaug tour."
    },
    {
        title: "Mandwa Beach",
        description:
            "Mandwa Beach is well known for its scenic coastline, luxury resorts, water sports, and ferry connectivity with Mumbai. Visitors enjoy relaxing by the beach, tasting local seafood, and experiencing beautiful views of the Mumbai skyline across the Arabian Sea."
    },
    {
        title: "Kanakeshwar Temple",
        description:
            "Kanakeshwar Temple is an ancient hilltop Shiva temple surrounded by dense greenery and peaceful forest trails. The temple offers a spiritual atmosphere along with panoramic views of the Konkan coastline, making it a popular destination for devotees, trekkers, and nature lovers visiting Alibaug."
    }
],

  "services": [
    {
      "name": "Pune to Alibaug Cab Service",
      "description": "Book Pune to Alibaug cab service for safe and comfortable travel covering approximately 145 km via Mumbai-Pune Expressway and coastal highways. Available for one-way drop, round trip, and weekend packages. AC sedan, SUV, Innova Crysta, and luxury cab options ensure comfort based on group size. Transparent per kilometer pricing includes base fare, driver allowance, and toll charges. Ideal for beach holidays, corporate outings, and family trips."
    },
    {
      "name": "Pune to Alibaug One Way Cab",
      "description": "Affordable Pune to Alibaug one way cab option for travelers not returning the same day. Pay only for single-side distance without unnecessary return fare. Suitable for vacationers and extended beach stays. Professional drivers ensure smooth highway travel."
    },
    {
      "name": "Pune to Alibaug Round Trip Taxi",
      "description": "Round trip taxi from Pune to Alibaug allows flexible return timing for sightseeing and beach exploration. Multi-day rental options available for weekend trips and group tours."
    },
    {
      "name": "Pune to Alibaug Taxi Fare",
      "description": "Check updated Pune to Alibaug taxi fare calculated on per kilometer basis. Fare varies depending on sedan, SUV, or premium vehicle category. Clear fare breakdown eliminates hidden charges."
    },
    {
      "name": "Pune to Alibaug Innova Cab",
      "description": "Premium Innova Crysta cab for Pune to Alibaug offering spacious seating and enhanced comfort. Ideal for larger families and corporate groups."
    },
    {
      "name": "Pune to Alibaug Ertiga Cab",
      "description": "Affordable Ertiga cab option suitable for small families and beach travelers seeking economical AC travel."
    },
    {
      "name": "Pune to Alibaug SUV Taxi",
      "description": "SUV taxi option for travelers seeking additional luggage space and comfort during coastal road journeys."
    },
    {
      "name": "Pune to Alibaug Weekend Trip Cab",
      "description": "Dedicated weekend trip cab service from Pune to Alibaug ideal for short vacations, beach outings, and corporate retreats."
    }
  ],

  "tableData": [
    ["Pune to Alibaug Cab Service", "Pune to Alibaug One Way Cab"],
    ["Pune to Alibaug Round Trip Taxi", "Pune to Alibaug Taxi Fare"],
    ["Pune to Alibaug Innova Cab", "Pune to Alibaug Ertiga Cab"],
    ["Pune to Alibaug SUV Taxi", "Pune to Alibaug Weekend Trip Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Reliable Coastal Travel",
      "WhyChoosedescription": "Safe and smooth journey from Pune to Alibaug with experienced highway drivers."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear billing structure with no hidden charges."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Flexibility",
      "WhyChoosedescription": "Flexible booking for weekend or extended beach trips."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Ertiga, and Innova categories available."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained vehicles for long-distance comfort."
    },
    {
      "WhyChooseheading": "Ideal for Family & Corporate Trips",
      "WhyChoosedescription": "Suitable for beach holidays and team outings."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Experienced drivers familiar with coastal routes."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for smooth booking."
    }
  ]
}






const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Alibaug cab service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Alibaug cab service for one-way and round trips with comfortable vehicles and experienced drivers for coastal travel.',
  },
  {
    question: 'What is the distance between Pune and Alibaug by cab?',
    answer: 'The distance from Pune to Alibaug is approximately 140–150 km depending on the route. Travel time usually takes around 3.5 to 4.5 hours.',
  },
  {
    question: 'What are the charges for Pune to Alibaug cab booking?',
    answer: 'Cab charges depend on vehicle type, trip type (one-way or round trip), and travel date. Lotus Cab offers competitive per km pricing with transparent billing.',
  },
  {
    question: 'Can I book a one-way Pune to Alibaug cab?',
    answer: 'Yes, Lotus Cab provides affordable one-way Pune to Alibaug cab services so customers only pay for the drop without return charges.',
  },
  {
    question: 'Which vehicles are available for Pune to Alibaug travel?',
    answer: 'We provide Sedan options like Dzire and Etios for couples and small families, and SUVs like Ertiga and Innova Crysta for group and family beach trips.',
  },
  {
    question: 'Is Pune to Alibaug cab service suitable for weekend trips?',
    answer: 'Absolutely. Lotus Cab is ideal for weekend beach getaways to Alibaug with flexible pickup timings and comfortable travel options.',
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll, parking, and entry charges (if applicable) are billed separately as per actuals. Lotus Cab ensures complete transparency before confirming your booking.',
  },
  {
    question: 'Can I book a round trip for 2 or 3 days to Alibaug?',
    answer: 'Yes, we offer multi-day round trip packages from Pune to Alibaug, perfect for beach holidays and family vacations.',
  },
  {
    question: 'Is cab service available for Alibaug sightseeing?',
    answer: 'Yes, Lotus Cab can provide extended services for Alibaug sightseeing including beaches, forts, and nearby attractions.',
  },
  {
    question: 'How can I book Pune to Alibaug cab with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, passenger details, and vehicle preference to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Shah',
    feedback: 'Booked Lotus Cab for Pune to Alibaug weekend trip. Smooth ride, clean car, and very professional driver. Highly recommended for beach travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Pooja Deshmukh',
    feedback: 'Excellent Pune to Alibaug cab service. Comfortable Innova, transparent pricing, and timely pickup. Perfect for our family getaway.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];





const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Alibaug Cab",
"image": "https://lotuscab.com/assets/images/pune-to-alibaug-cab.jpg",
"description": "Book Pune to Alibaug Cab with Lotus Cab for safe, comfortable, and affordable coastal travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6884"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-alibaug-cab"
}
};















  return (
    <div>
      
<Helmet>
  <title>Pune to Alibaug Cab | One Way & Round Trip Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Alibaug Cab with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and 24x7 customer support for a smooth coastal trip."
/>

<meta
 name="keywords"
 content="Pune to Alibaug Cab, Pune to Alibaug Taxi, Pune to Alibaug Cab Service, Pune to Alibaug Taxi Service, Alibaug Cab from Pune, One Way Cab Pune to Alibaug, Round Trip Cab Pune to Alibaug, Outstation Cab Pune to Alibaug, Pune to Alibaug Beach Cab, Mumbai Coastal Cab Pune to Alibaug, Affordable Pune to Alibaug Cab, Cheap Pune to Alibaug Taxi, Online Pune to Alibaug Cab Booking, Sedan Cab Pune to Alibaug, SUV Cab Pune to Alibaug, Best Pune to Alibaug Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoalibaugcab;